import './polyfills/react-polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';

// import "normalize.css";
// import "./base.css";
import App from './App';

const ROOT_NODE = document.getElementById('root');
const root = createRoot(ROOT_NODE);

const render = () => root.render(<App />);

if (module.hot) module.hot.accept('./App', render);
render();
